import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import { Button, Form } from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
// import bgimage from '../../../../images/default_staff.png'; 
import swal from "sweetalert2";
import FileUpload from "react-material-file-upload";     
import axios from 'axios';
import bgimage from '../../../../images/vendor/vendor.png';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const EditVendors = () => {
  // const { sno } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');
  const navigate = useNavigate();
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  // Vendor data fetched from API
  const [vendorData, setVendorData] = useState(null); 

  // Dropdown options and selected states
  const [categories, setCategories] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);

  // Settlement Type dropdown options and selected
  const settlement_type_option = [
    { value: "0", label: "Weeks" },
    { value: "1", label: "Months" },
    { value: "2", label: "Years" },
  ];
  const [selectedSettlementType, setSelectedSettlementType] = useState(null);

  // Form field states
  const [businessName, setBusinessName] = useState('');
  const [email, setEmail] = useState('');
  const [vendorMobile, setVendorMobile] = useState('');
  const [settlementTypeInput, setSettlementTypeInput] = useState('');
  const [openingBalanceAmount, setOpeningBalanceAmount] = useState('');
  const [address, setAddress] = useState('');
  const [personName, setPersonName] = useState('');
  const [personRole, setPersonRole] = useState('');
  const [personMobile, setPersonMobile] = useState('');
  const [businessRegNo, setBusinessRegNo] = useState('');
  const [gstNo, setGstNo] = useState('');
  const [taxNo, setTaxNo] = useState('');
  const [personAltMobile, setPersonAltMobile] = useState('');
  const [altMobile, setAltMobile] = useState('');
  const [description, setDescription] = useState('');
  const [bankName, setBankName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');

  const [Checked, setChecked] = useState(false); // bank info shown or hidden
  const [openingBalanceType, setOpeningBalanceType] = useState(null);

  // File upload states
  const [file, setFile] = useState(null); // vendor image
  const [files, setFiles] = useState([]); // attachments

  const imageInputRef = useRef(null);

  // Fetch categories
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/vendorcategory/category/active`)
      .then(response => {
        const options = response.data.map(category => ({
          value: category.sno,
          label: category.vendorcategory_name,
        }));
        setCategories(options);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  // Fetch business types
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/businesstype/type/active`)
      .then(response => {
        const options = response.data.map(type => ({
          value: type.sno,
          label: type.businesstype_name,
        }));
        setBusinessTypes(options);
      })
      .catch(error => {
        console.error('Error fetching business types:', error);
      });
  }, []);

  // Fetch vendor data
  useEffect(() => {
    if (sno) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/managevendor/${sno}`)
        .then(res => {
          setVendorData(res.data.vendor);
        })
        .catch(err => {
          console.error("Failed to fetch vendor:", err);
          swal.fire("Error", "Unable to fetch vendor data", "error");
        });
    }
  }, [sno]);

  // Set selectedCategory when vendorData and categories loaded
  // useEffect(() => {
  //   if (vendorData && categories.length > 0) {
  //     const matchedCategory = categories.find(
  //       cat => cat.value === vendorData.vendor_category?.id
  //     );
  //     setSelectedCategory(matchedCategory || null);
  //   }
  // }, [vendorData, categories]);

  // // Set selectedBusinessType when vendorData and businessTypes loaded
  // useEffect(() => {
  //   if (vendorData && businessTypes.length > 0) {
  //     const matchedBusinessType = businessTypes.find(
  //       type => type.value === vendorData.business_type?.id
  //     );
  //     setSelectedBusinessType(matchedBusinessType || null);
  //   }
  // }, [vendorData, businessTypes]);


useEffect(() => {
  if (vendorData && categories.length > 0) {
    const matchedCategory = categories.find(
      cat => cat.value === vendorData.vendor_category?.sno  // use sno here
    );
    setSelectedCategory(matchedCategory || null);
  }
}, [vendorData, categories]);

useEffect(() => {
  if (vendorData && businessTypes.length > 0) {
    const matchedBusinessType = businessTypes.find(
      type => type.value === vendorData.business_type?.sno  // use sno here
    );
    setSelectedBusinessType(matchedBusinessType || null);
  }
}, [vendorData, businessTypes]);


  // Set selectedSettlementType when vendorData loads
  useEffect(() => {
    if (vendorData?.select_type !== undefined) {
      const matchedOption = settlement_type_option.find(
        option => option.value === String(vendorData.select_type)
      );
      setSelectedSettlementType(matchedOption);
    }
  }, [vendorData]);

  // Populate form fields when vendorData loads
  useEffect(() => {
    if (vendorData) {
      setBusinessName(vendorData.vendor_businessname || '');
      setEmail(vendorData.vendor_emailid || '');
      setVendorMobile(vendorData.vendor_mobileno || '');
      setSettlementTypeInput(vendorData.settlement_type || '');
      setOpeningBalanceAmount(vendorData.opening_balance_amount || '');
      setAddress(vendorData.address || '');
      setPersonName(vendorData.person_name || '');
      setPersonRole(vendorData.person_role || '');
      setPersonMobile(vendorData.person_mobileno || '');
      setBusinessRegNo(vendorData.business_regno || '');
      setGstNo(vendorData.gstno || '');
      setTaxNo(vendorData.taxno || '');
      setPersonAltMobile(vendorData.person_alternative_no || '');
      setAltMobile(vendorData.alternative_no || '');
      setDescription(vendorData.description || '');
      setBankName(vendorData.bank_name || '');
      setBranchName(vendorData.branch_name || '');
      setAccountHolderName(vendorData.account_holder_name || '');
      setAccountNumber(vendorData.account_no || '');
      setIfscCode(vendorData.ifsc_code || '');
      setChecked(vendorData.bank_information === 0);
      setOpeningBalanceType(vendorData.opening_balance);
    }
  }, [vendorData]);

  // Handlers for file uploads
  const handleFileChange = (newFiles) => {
    setFiles((prevFiles) => {
      const combinedFiles = [...prevFiles, ...newFiles];
      return combinedFiles.slice(0, 4);
    });
  };

  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
  };

  // Checkbox for bank info
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  
// Form submission logic without event (no e.preventDefault)
const submitForm = async () => {
  if (!selectedCategory) {
    swal.fire("Validation Error", "Please select a category", "warning");
    return;
  }
  if (!selectedBusinessType) {
    swal.fire("Validation Error", "Please select a business type", "warning");
    return;
  }
  if (!selectedSettlementType) {
    swal.fire("Validation Error", "Please select a settlement type", "warning");
    return;
  }

  const formData = new FormData();

  formData.append("vendor_category", selectedCategory.value);
  formData.append("vendor_businessname", businessName);
  formData.append("vendor_mobileno", vendorMobile);
  formData.append("vendor_emailid", email);
  formData.append("business_type", selectedBusinessType.value);
  formData.append("settlement_type", settlementTypeInput);
  formData.append("select_type", selectedSettlementType.value);
  formData.append("opening_balance", openingBalanceType); // 0 or 1
  formData.append("opening_balance_amount", openingBalanceAmount);
  formData.append("address", address);
  formData.append("person_name", personName);
  formData.append("person_role", personRole);
  formData.append("person_mobileno", personMobile);

  formData.append("business_regno", businessRegNo || "");
  formData.append("gstno", gstNo || "");
  formData.append("taxno", taxNo || "");
  formData.append("person_alternative_no", personAltMobile || "");
  formData.append("alternative_no", altMobile || "");
  formData.append("description", description || "");
  formData.append('updated_by', user_id);
  const bankInfoValue = Checked ? 0 : 1; // 0 = shown, 1 = hidden
  formData.append("bank_information", bankInfoValue);
  if (bankInfoValue === 0) {
    formData.append("bank_name", bankName);
    formData.append("branch_name", branchName);
    formData.append("account_holder_name", accountHolderName); 
    formData.append("account_no", accountNumber);
    formData.append("ifsc_code", ifscCode);
  }

  if (file) {
    formData.append("vendor_image", file);
  }

  files.forEach((fileItem) => {
    formData.append(`attachments[]`, fileItem);
  });

 

  try {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/managevendor/${sno}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  navigate('/manage-vendors', {
      state: { toastMessage: 'Vendor Updated Successfully!', toastType: 'success' }
  });


} catch (error) {
  console.error("Error updating vendor:", error);
  navigate('/manage-vendors', {
      state: { toastMessage: 'Error Updating Vendor', toastType: 'error' }
  });
}

};

// The confirmation popup, calls submitForm() if confirmed
const handleUpdateClick = () => {
  swal.fire({
    html: `
      <div class="alert alert-success px-2 py-2" role="alert">
          Are You Sure Want to Update Vendor
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <p class="text-center"><b>Reliance Mart</b></p>
      <div class="text-center">
        <!-- Your SVG here -->
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Yes!',
    cancelButtonText: 'No',
    reverseButtons: true,
    customClass: {
      title: 'fs-6',
      cancelButton: 'btn btn-sm btn-secondary',
      confirmButton: 'btn btn-sm btn-success',
      htmlContainer: 'text-left'
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then((result) => {
    if (result.isConfirmed) {
      submitForm();
    }
  });
};


return (
  <>
    <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
      <div className="mb-2">
        <div className="mb-0 px-0">
          <h4 style={{ color: "#025d3a" }}>Update Vendor</h4>
        </div>
        <ol className="breadcrumb fs-7">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item">
            <i className="fa-solid fa-angles-right fs-8"></i>
          </li>
          <li className="breadcrumb-item">Purchase Management</li>
          <li className="breadcrumb-item">
            <i className="fa-solid fa-angles-right fs-8"></i>
          </li>
          <li className="breadcrumb-item active">
            <Link to="/manage-items">Manage Vendors</Link>
          </li>
        </ol>
      </div>
    </div>

    <label className="text-red fs-4 fw-bold mb-3">Basic Information</label>

    <div className="row">
      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          {" "}
          Category <span className="required">*</span>
        </label>
        <Select
          placeholder="Select Category"
          value={selectedCategory}
          options={categories}
          onChange={setSelectedCategory}
        />
      </div>

      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          Vendor Business Name <span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Vendor Business Name"
          value={businessName}
          onChange={(e) => setBusinessName(e.target.value)}
          required
        />
      </div>
 

      <div className="col-lg-4 mb-4">
  <label className="text-black font-w500 fs-7">
    Vendor Mobile No <span className="required">*</span>
  </label>
  <input
    type="text"
    className="form-control"
    placeholder="Enter Vendor Mobile No"
    value={vendorMobile}
    onChange={(e) => {
      const value = e.target.value;
      // Allow only numbers
      if (/^\d{0,10}$/.test(value)) {
        // Allow empty or first digit is 6-9
        if (value === '' || /^[6-9]/.test(value)) {
          setVendorMobile(value);
        }
      }
    }}
    maxLength="10"
    required
  />
</div>


      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          Email Id<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Email Id"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          Business Type<span className="required">*</span>
        </label>
        <Select
          placeholder="Select Business Type"
          value={selectedBusinessType}
          options={businessTypes}
          onChange={setSelectedBusinessType}
        />
      </div>

      <div className="col-lg-4 mb-4 ">
        <label className="text-black font-w500 fs-7">
          Settlement Type<span className="required">*</span>
        </label>
        <div className="row">
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Settlement Type"
              value={settlementTypeInput}
              onChange={(e) => setSettlementTypeInput(e.target.value)}
            />
          </div>
          <div className="col-lg-6">
            <Select
              placeholder="Select Type"
              value={selectedSettlementType}
              onChange={setSelectedSettlementType}
              options={settlement_type_option}
            />
          </div>
        </div>
      </div>


      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">CIN</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter CIN"
          value={businessRegNo}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            const cinPattern = /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;

            if (/^[A-Z0-9]{0,21}$/.test(value)) {
              // Allow input as long as it's valid
              if (value.length < 21 || cinPattern.test(value)) {
                setBusinessRegNo(value);
              }
            }
          }}
          maxLength="21"
        />
      </div>


        <div className="col-lg-4 mb-4">
          <label className="text-black font-w500 fs-7">GST No</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter GST No"
            value={gstNo}
            onChange={(e) => {
              const value = e.target.value.toUpperCase();
              const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

              if (/^[A-Z0-9]{0,15}$/.test(value)) {
                // Allow input as long as it's valid
                if (value.length < 15 || gstPattern.test(value)) {
                  setGstNo(value);
                }
              }
            }}
            maxLength="15"
          />
        </div>

 

      <div className="col-lg-4 mb-4">
  <div className="d-flex align-items-center justify-content-between">
    <div>
      <label className="text-black font-w500 fs-7">
        Outstanding Amount<span className="required">*</span>
      </label>
    </div>
  </div>

  <input
    type="text"
    className="form-control"
    placeholder="Enter Opening Balance"
    value={openingBalanceAmount || 0}
    onChange={(e) => {
      const value = e.target.value;
      // Allow only digits and max 15 characters
      if (/^\d{0,15}$/.test(value)) {
        setOpeningBalanceAmount(value);
      }
    }}
    maxLength="15"
    required
  />
</div>



      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          Address<span className="required">*</span>
        </label>
        <textarea
          className="form-control"
          name="comment"
          placeholder="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          required
        />
      </div>

      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7 d-block">Vendor Image</label>
            <span className='fs-8 text-gray-800'>Size: </span>
            <span className='fs-8 text-danger'>15 * 15</span> 
            <span className='fs-8 text-gray-800 ms-2'>Format: </span>
            <span className='fs-8 text-danger'>.png, .jpg</span>
        <div className="avatar-upload d-flex align-items-center">
          <div className="change position-relative">
            <div
              className="avatar-preview h-100px w-100px border"
              style={{ borderRadius: "10px" }}
            >
              <img
                id="saveImageFile"
                src={file ? URL.createObjectURL(file) : bgimage}
                alt={file ? file.name : "Default Avatar"}
                className="p-1 h-100px w-100px"
              />
            </div>
            <div className="change-btn">
              <input
                type="file"
                id="imageUpload"
                accept=".png, .jpg, .jpeg"
                style={{ display: "none" }}
                onChange={fileHandler}
                ref={imageInputRef}
              />
              <div className="mt-2 d-flex justify-content-center gap-3">
                <Button
                  className="btn-xs mb-2"
                  variant="success"
                  onClick={() => imageInputRef.current.click()}
                >
                  <span className="">
                    <i className="fa fa-upload color-success fs-5" />
                  </span>
                </Button>
                <Button
                  className="btn-xs mb-2"
                  variant="danger"
                  onClick={RemoveImage}
                >
                  <span className="">
                    <i className="fa fa-close color-danger fs-5" />
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <label className="text-red font-w600 fs-4 mb-3">Contact Information</label>

    <div className="row">
      <div className="col-lg-4 mb-4">
        <label className="text-black font-w500 fs-7">
          Primary Contact Person Name<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Primary Contact Person Name"
          value={personName}
          onChange={(e) => setPersonName(e.target.value)}
          required
        />
      </div>
      <div className="col-lg-4  mb-4 ">
        <label className="text-black font-w500 fs-7">
          Role/Positon<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Role/Positon"
          value={personRole}
          onChange={(e) => setPersonRole(e.target.value)}
          required
        />
      </div>
      <div className="col-lg-4  mb-4">
        <label className="text-black font-w500 fs-7">
          Primary Mobile No <span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Primary Mobile No"
          value={personMobile}
          onChange={(e) => setPersonMobile(e.target.value)}
          required
        />
      </div>
      <div className="col-lg-4  mb-4">
        <label className="text-black font-w500 fs-7">
          Alternate Contact Person Name
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Secondary Contact Person Name "
          value={personAltMobile}
          onChange={(e) => setPersonAltMobile(e.target.value)}
        />
      </div>
      <div className="col-lg-4  mb-4">
        <label className="text-black font-w500 fs-7">Alternate Mobile No</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Secondary Mobile No"
          value={altMobile}
          onChange={(e) => setAltMobile(e.target.value)}
        />
      </div>
    </div>
    
   
 
        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="bankInfoCheck"
            checked={Checked}
              onChange={() => setChecked(!Checked)}
          />
         <label className="text-red fs-4 font-w600 mb-3" htmlFor="customCheckBox1">Bank Information</label>
        </div>

      {Checked && ( 
        <>
        <div className='row'>
          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Bank Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Bank Name"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Branch Name</label>
            <input
                type="text"
                className="form-control"
                placeholder="Enter Branch Name"
                value={branchName}
                onChange={(e) => setBranchName(e.target.value)}
            />
            </div>

          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">Account No</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Account No"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mb-4">
            <label className="text-black font-w500 fs-7">IFSC Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter IFSC Code"
              value={ifscCode}
              onChange={(e) => setIfscCode(e.target.value)}
            />
          </div>
        </div>
        </>
      )}
    

      <div className='row'>
    
        <div className='col-lg-6 mb-4'>
            <label className="text-black font-w500 fs-7">Attachment</label>
            <div className='mt-2'>
                <FileUpload
                    maxFiles={4}
                    value={files}
                    onChange={handleFileChange}
                />
            </div>
        </div>
        <div className='col-lg-6 mt-1'>
            <label className="text-black font-w500 fs-7">Description</label>
            <textarea rows={6} className="form-control h-auto" name="comment" placeholder="Description" defaultValue={vendorData?.description} />
        </div>
    </div>
    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 ">
        <Link to={'/manage-vendors'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
        {/* <Link type="submit" className="btn btn-sm btn-primary" onClick={handleUpdateClick} >Update Vendor</Link> */}
        <button type="button" className="btn btn-sm btn-primary" onClick={handleUpdateClick}>Update Vendor</button>

    </div>
  </>
);



}
export default EditVendors;